/* eslint-disable no-use-before-define */
import React from 'react'
import { openWindow } from '../twd'

export default () => <React.Fragment>
    <div style={{backgroundColor:"#f6f6f6"}}>
    <div className="container">
    <div className="row vertical-offset-xxxl" ></div>

    <div className="row">
    <div className="card-group card-group-center">
        <div className="card card-primary flex-xs-12 flex-md-5">

        <div className="card-body text-center">
            <h2>Questions regarding your Fixed Income Portfolio Report?</h2>

            <p className="vertical-offset-sm">
            Our Fixed Income Specialists can help provide additional clarity on your report.
            Call us at <a style={{textDecoration:'underline'}} alt="877-355-3237" href="tel:18773553237" aria-label="877-355-3237">
            877-355-3237</a> for assistance.
            </p>

            <p><button className="btn btn-lg btn-primary-outline"
                onClick={() => {
                    window.open("tel:18773553237")
                }}
            >Call now</button></p>
        </div>
        </div>

        <div className="card card-primary flex-xs-12 flex-md-5">
        <div className="card-body text-center">
            <h2>Personalized advice from a Morgan Stanley Financial Advisor</h2>

            <p className="vertical-offset-sm">
            Now that E*TRADE and Morgan Stanley have joined forces, you can work with
            a Morgan Stanley Financial Advisor for additional guidance and support managing
            your fixed income investments.
            </p>

            <p><button className="btn btn-lg btn-primary-outline"
                onClick={() => {
                    openWindow("https://us.etrade.com/c/s/what-we-offer/msfa")
                }}
            >Get advice</button></p>

            <p className="text-muted small">
            Eligibility requirements apply.
            </p>
        </div>

        </div>
    </div>
    </div>

    <div className="row vertical-offset-xxxl" ></div>

    </div>
    </div>

    <div className="container">
    <div className="row vertical-offset-lg" ></div>
    <div className="row xs-hide">
        <div className='col-md-6' style={{height:'25px'}}>
            <div style={{display:'inline', verticalAlign:'bottom', height:'25px'}}>The bond resource center is powered by</div>
            <img alt="tradeweb" aria-hidden={true} src="./resources/images/tradeweb-logo.svg" />
        </div>
        <div className='col-md-6' style={{height:'25px'}}>
            <div style={{position:'absolute', right:0, bottom:0}}>All data provided by Tradeweb Markets LLC unless otherwise noted.</div>
        </div>
    </div>
    <div className="row xs-show">
        <div className='col-xs-12 text-center'>
            The bond resource<br/>center is powered by<br/>
            <img alt="tradeweb" aria-hidden={true} src="./resources/images/tradeweb-logo.svg" />
            <br/>
            <br/>
            All data provided by Tradeweb Market<br/>
            LLC unless otherwise noted.
        </div>
    </div>
    <div className="row vertical-offset-lg" ></div>
    </div>
    </React.Fragment>
